import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon-success-order',
    templateUrl: './icon-success-order.component.html',
    styleUrls: ['./icon-success-order.component.scss']
})
export class IconSuccessOrderComponent implements OnInit {

    @Input() cssClass: string;

    constructor() { }

    ngOnInit(): void {
    }

}
